import { Exception } from '../../../core/logic/exception';

export class ResourceNotFoundException extends Exception<never> {
  constructor() {
    super('Ressource non trouvée');
  }
}
